/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import pinia from '../stores';
import router from '../router';
import axios from './axios';
import { Icon } from '@iconify/vue';

// Types
import type { App } from 'vue';

export function registerPlugins(app: App) {
    pinia.use(({ store }) => {
        store.$router = markRaw(router);
    });

    app.use(router).use(pinia).component('Icon', Icon).provide('axios', axios);
}
